//#region src/utils/iconDefaults.ts
var e = "size-4 shrink-0 [&_path]:fill-current";
//#endregion
export { e as DEFAULT_ICON_CLASS_NAME };
